const isSameOriginOrBlob = (url) => {
  if (url.startsWith('blob:')) {
    return true;
  }

  try {
    return new URL(url, window.location.href).origin === window.location.origin;
  } catch {
    return false;
  }
};

const downloadFile = (url, fileName = '') => {
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName || url.split('/').pop();

  if (!isSameOriginOrBlob(url)) {
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
  }

  link.click();
  link.remove();
};

export default downloadFile;
